import { useCallback } from 'react';

import qs from 'qs';

import { usePsfSharePageData } from 'src/app/pages/psf/share/pageContext';
import { useSession } from 'src/app/shared/hooks/session';
import { useIsMobile } from 'src/app/shared/hooks/userAgent';

type Result = (options: { pathSuffix?: string; medium: string; additionalParams?: Record<string, string> }) => string;

export function useGenPetitionUrl(): Result {
	const session = useSession();
	const isMobile = useIsMobile();
	const {
		data: {
			initial,
			petition: { slug, bestShareVisual },
			featureConfigs: { hideRecruiter, isShareAssetsEnabled },
			desktopShareAssetsExperiment,
		},
	} = usePsfSharePageData();

	const sessionUuid = session.uuid;
	const currentUserId = session.user?.id || undefined;
	const currentCampaign = session.trackingData.current_campaign || undefined;

	const isDesktopWithShareAssets =
		!isMobile && !['control', 'fake_control'].includes(desktopShareAssetsExperiment.variation);
	const shouldUseBsvPath = ((isShareAssetsEnabled && isMobile) || isDesktopWithShareAssets) && !!bestShareVisual?.url;

	return useCallback(
		({ pathSuffix, medium, additionalParams }) => {
			const effectivePathSuffix = shouldUseBsvPath ? `${pathSuffix ?? ''}/bsv` : (pathSuffix ?? '');

			const trackParams = qs.stringify(
				{
					...(hideRecruiter
						? {}
						: {
								recruiter: currentUserId || undefined,
								recruited_by_id: sessionUuid,
							}),
					utm_source: 'share_petition',
					utm_campaign: initial ? 'psf_combo_share_initial' : 'psf_combo_share_message',
					utm_term: currentCampaign,
					utm_medium: medium,
					...additionalParams,
				},
				{ encodeValuesOnly: true },
			);
			return `/p/${slug}${effectivePathSuffix}?${trackParams}`;
		},
		[initial, sessionUuid, currentUserId, slug, currentCampaign, hideRecruiter, shouldUseBsvPath],
	);
}
